module.exports = __webpack_public_path__ + "img/log_blue.294e8631.svg";